<template>
  <div>
    <div class="container-fluid">
      <div class="row justify-content-around">
        <div class="col-md-6">
          <vs-card>
            <div class="container-fluid">
              <div class="row justify-content-around">
                <div class="col-md-12">
                  <vs-table stripe :data="[1]">
                    <template slot-scope="{}">
                      <vs-tr>
                        <vs-td class="w-25">{{$t("productName")}}</vs-td>
                        <vs-td>
                          <vs-input
                            class="w-full"
                            v-validate="'required|min:3'"
                            data-vv-validate-on="blur"
                            :name="$t('productName')"
                            :label-placeholder="$t('value')"
                            v-model="sendData.Name"
                          />
                          <span class="text-danger text-sm">{{ errors.first($t('productName')) }}</span>
                        </vs-td>
                      </vs-tr>
                      <vs-tr>
                        <vs-td class="w-25">{{$t("productCode")}}</vs-td>
                        <vs-td>
                          <vs-input
                            class="w-full"
                            v-validate="'required|min:3'"
                            data-vv-validate-on="blur"
                            :name="$t('productCode')"
                            :label-placeholder="$t('value')"
                            v-model="sendData.ProductCode"
                          />
                          <span class="text-danger text-sm">{{ errors.first($t('productCode')) }}</span>
                        </vs-td>
                      </vs-tr>
                      <vs-tr>
                        <vs-td class="w-25">{{$t("barcod")}}</vs-td>
                        <vs-td>
                          <vs-input
                            class="w-full"
                            v-validate="'required|min:3'"
                            data-vv-validate-on="blur"
                            :name="$t('barcod')"
                            :label-placeholder="$t('value')"
                            v-model="sendData.ProductBarcode"
                          />
                          <span class="text-danger text-sm">{{ errors.first($t('barcod')) }}</span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </vs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["sendData"],
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.sendData.Name != "" &&
        this.sendData.ProductCode != "" &&
        this.sendData.ProductBarcode != ""
      );
    },
  },
};
</script>

<style>
</style>